import type { AxiosInstance } from 'axios';

const TEAM_ID_HEADER = `x-sine-team-id`;
const TEAM_ID_ERROR = 'MISSING_TEAM_ID';

export default class TeamInterceptor {
  private getCurrentTeamId: () => string;
  private axiosInstance: AxiosInstance;
  private axiosResponseSubscriptionId?: number;
  private axiosRequestSubscriptionId?: number;

  constructor(axiosInstance: AxiosInstance, getCurrentTeam: () => string) {
    this.axiosInstance = axiosInstance;
    this.getCurrentTeamId = getCurrentTeam;
  }

  public startIntercepting() {
    this.axiosResponseSubscriptionId = this.axiosInstance.interceptors.response.use(
      (axiosResponse) => axiosResponse,
      this.handleAxiosError,
    );
    this.axiosRequestSubscriptionId = this.axiosInstance.interceptors.request.use(
      (axiosRequest) => {
        const currentTeam = this.getCurrentTeamId();

        // Whitelist all default
        const urlsNotRequiringTeamId = ['/auth/device/recaptcha', '/devices/register'];
        const shouldNotSendTeamIdHeader = urlsNotRequiringTeamId.some((url) => axiosRequest.url?.includes(url));

        if (currentTeam) {
          if (shouldNotSendTeamIdHeader) {
            return axiosRequest;
          }

          axiosRequest.headers[TEAM_ID_HEADER] = currentTeam;
        }
        return axiosRequest;
      },
      (error) => error,
    );
  }

  public stopIntercepting() {
    if (this.axiosResponseSubscriptionId) {
      this.axiosInstance.interceptors.response.eject(this.axiosResponseSubscriptionId);
      this.axiosResponseSubscriptionId = undefined;
    }
    if (this.axiosRequestSubscriptionId) {
      this.axiosInstance.interceptors.request.eject(this.axiosRequestSubscriptionId);
      this.axiosRequestSubscriptionId = undefined;
    }
  }

  private async handleAxiosError(error: any) {
    const status = error?.response?.status;
    const statusTest = error?.response?.statusText;
    const code = error?.data?.code;

    if (status === 400 && [statusTest, code].includes(TEAM_ID_ERROR)) {
      // eslint-disable-next-line no-console
      console.warn('No team id yo');
    }

    return Promise.reject(error);
  }
}
